import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';
import { RemoteAssistanceTaskParamE } from './remote-assistance.const';

@Injectable({ providedIn: 'root' })
export class RemoteAssistanceStrService {
    get = this.i18nService.get;

    i18n = {
        agreeBtn: this.get('home.DMEIQ_remoteAssistance_agree_btn'),
        rejectBtn: this.get('home.DMEIQ_remoteAssistance_reject_btn'),
        confirmBtn: this.get('common.confirm_button'),
        cancelBtn: this.get('common.cancel_button'),
        endBtn: this.get('settings.alarmNotification_maintenanceWindow_end_btn'),
        assistingTitle: this.get('home.DMEIQ_remoteAssistance_inProgress_info'),
        establishingAssistingTitle: this.get('home.DMEIQ_remoteAssistance_establishing_info'),
        endAssistingTitle: this.get('home.DMEIQ_remoteAssistance_ending_info'),
        reconnectionAssistingTitle: this.get('home.DMEIQ_remoteAssistance_reconnecting_info'),
        remainingTime: this.get('home.DMEIQ_remoteAssistance_remainTime_lab', [], true),
        minutes: (minutes: number | string): string => this.get('service.KeepaliveTime_minute', [minutes]),
        requestTitle: this.get('home.DMEIQ_remoteAssistance_agree_title'),
        requestContent: this.get('home.DMEIQ_remoteAssistance_agree_confirm_msg'),
        endRequestTitle: this.get('home.DMEIQ_remoteAssistance_end_title'),
        endRequestContent: this.get('home.DMEIQ_remoteAssistance_end_confirm_msg'),
        agreeRemoteAssistanceTip: this.get('home.DMEIQ_remoteAssistance_allow_confirm_msg'),
        remoteAssistanceTitleTip: this.get('home.DMEIQ_remoteAssistance_inProgress_info2'),

        agreeRest: this.get('rest.agreeDMEIQRemoteAssistance_msg'),
        rejectRest: this.get('rest.rejectDMEIQRemoteAssistance_msg'),
        endRest: this.get('rest.endDMEIQRemoteAssistance_msg'),
    };

    /**
     * 处理远程协议的rest名称
     */
    restName = {
        [RemoteAssistanceTaskParamE.ACCEPT]: this.i18n.agreeRest,
        [RemoteAssistanceTaskParamE.REJECT]: this.i18n.rejectRest,
        [RemoteAssistanceTaskParamE.TERMINATE]: this.i18n.endRest,
    };

    constructor(
        private i18nService: I18nService,
    ) {}
}
